import ServiceFactory from '@src/services/service-factory';
import zt from '@src/services/json/zt/zt';
// import xoyo from '@src/services/json/zt/xoyo';
import ServiceResponseError from '@src/error/ServiceResponseError';
import Json from '@src/services/json/zt/Json';
import UnmountError from '@src/error/UnmountError';
import { ZT_ROOT_ADDRESS } from '@src/constants/urls';

const getTimestamp = function() {
  const time = new Date();
  const year = time.getFullYear();
  const day = time.getDate();
  const month = time.getMonth();
  const hour = time.getHours();
  const min = time.getMinutes();
  return new Date(year, month, day, hour, parseInt(min / 10, 10) * 10).getTime();
};

export default class JsonService extends ServiceFactory {
  // static baseURL = `${ANTI_ADDICTION_ADDRESS}/`;

  /**
   * 获取默认实例方法, 用于非 component 中使用等情况
   * @type {import('@src/services/json/zt/services.d.ts').IGeneratedServices}
   */
  static getDefaultInstance(serviceOption) {
    if (!JsonService._ztServiceInstance) {
      JsonService._ztServiceInstance = new JsonService({ serviceOption }).createZTService();
    }
    // noinspection JSValidateTypes
    return JsonService._ztServiceInstance;
  }

  static getXoyoDefaultInstance(serviceOption) {
    if (!JsonService._xoyoServiceInstance2) {
      JsonService._xoyoServiceInstance = new JsonService({ serviceOption }).createXOYOService();
    }
    // noinspection JSValidateTypes
    return JsonService._xoyoServiceInstance;
  }

  json = null;

  constructor({ checkIfComponentUnmount, serviceOption } = {}) {
    super({
      /**
       * 队列映射
       * 详细请参考: https://gitlab.xsjcs.cn/xfe/xfe-iframe-application/blob/request-queue/parent/README.md
       * @type {{'jx3/ticket190728/create_order': string}}
       */
      queueMap: {
        /* 'jx3/ticket190728/create_order': 'jx3master' */
      },
      /**
       * 缓存时间, 默认: 100ms
       */
      optimizeUsingCache: 100
    });

    this.json = new Json({
      baseURL: JsonService.baseURL,
      ...serviceOption
    });
    this.handleCheckIfComponentUnmount(checkIfComponentUnmount);
  }

  request() {
    return {
      post: (rawUrl, rawParams) => {
        return this.handleCache(
          () => JSON.stringify({ rawUrl, rawParams }),
          async () => {
            const { url, params } = await this.interceptBeforeRequest({ rawUrl, rawParams });
            const queueMapKey = this.getQueueMapKey(url);
            let requestPromise;
            if (queueMapKey) {
              requestPromise = this.makeQueueRequest(this.queueMap[queueMapKey], params);
            } else {
              requestPromise = this.makeNativeJsonpRequest().post(url, params);
            }
            return requestPromise
              .then(responseValue => {
                return this.interceptAfterRequestSuccess({ requestOptions: { url, params }, responseValue });
              })
              .catch(async errorResponseValue => {
                throw await this.interceptAfterRequestError({ requestOptions: { url, params }, errorResponseValue });
              });
          }
        );
      },
      get: (rawUrl, rawParams) => {
        return this.handleCache(
          () => JSON.stringify({ rawUrl, rawParams }),
          async () => {
            const { url, params } = await this.interceptBeforeRequest({ rawUrl, rawParams });
            const queueMapKey = this.getQueueMapKey(url);
            let requestPromise;
            if (queueMapKey) {
              requestPromise = this.makeQueueRequest(this.queueMap[queueMapKey], params);
            } else {
              requestPromise = this.makeNativeJsonpRequest().get(url, params);
            }
            return requestPromise
              .then(responseValue => {
                return this.interceptAfterRequestSuccess({ requestOptions: { url, params }, responseValue });
              })
              .catch(async errorResponseValue => {
                throw await this.interceptAfterRequestError({ requestOptions: { url, params }, errorResponseValue });
              });
          }
        );
      }
    };
  }

  makeNativeJsonpRequest() {
    return this.json;
  }

  /**
   * 处理检查组件是否被卸载
   * @private
   */
  handleCheckIfComponentUnmount(checkIfComponentUnmount) {
    if (!checkIfComponentUnmount) {
      return;
    }
    const action = () => {
      if (checkIfComponentUnmount() === true) {
        throw new UnmountError();
      }
    };
    this.beforeRequests.push(action);
    this.afterRequestSuccessList.push(action);
    this.afterRequestErrorList.push(action);
  }

  createZTService(option) {
    return zt(
      { post: this.request().post.bind(this), get: this.request().get.bind(this) },
      response => Promise.reject(new ServiceResponseError(response)),
      ZT_ROOT_ADDRESS
    );
  }

  createXOYOService(option) {
    // return xoyo({ post: this.request().post.bind(this), get: this.request().get.bind(this) }, response => Promise.reject(new ServiceResponseError(response)));
  }
}
